<div class="disclaimer" fxLayout="column">
    <div fxLayoutAlign="center center">
        <h2 style="text-align: center">Provisional Quotation and or Pro-forma Invoice Given Without Prejudice</h2>
    </div>
    <p>This provisional quotation and or pro-forma invoice:</p>
    <ol>
        <li>
            <b>only applies to persons:</b>
            <ol class="sub-list-items">
                <li>with South African citizenship; or</li>
                <li>who are in possession of a valid permanent residence permit; and/or</li>
                <li>who do not follow a so-called "Short Course".</li>
            </ol>
        </li>
    </ol>
    <p><b><i>Other international students must return to the previous screen and select "International student".</i></b></p>
    <ol start="2" class="second-list">
        <li>
            does not take prerequisite and co-requisite modules, prerequisite pass, exclusion subjects, 
            required number of credits or allowed number of credits into account. The required amount 
            of credits as stipulated in the quote is indicative only and shall serve as a guideline when 
            selecting modules, with an aim to assist the applicant secure that the total amount of credits 
            of selected modules and check that these corresponds more or less with the required amount of 
            credits. If in doubt about the curriculum of the intended programme to be followed, please 
            refer to the particular Calendar of the Faculty,
        </li>
        <li>
            does not take the previous academic record into account,
        </li>
        <li>
            does not allow a quotation for more than one programme per enquiry; quotations for different programmes must be requested individually,
        </li>
        <li>
            does in no way confirm admission to the programme applied for or placement in residence,
        </li>
        <li>
            only offers an estimate of the cost of study, although it is aimed at offering an amount as close as possible to the real cost,
        </li>
        <li>
            estimates for textbooks can be obtained from book stores,
        </li>
        <li>
            is offered with the understanding that University Executive, Management, Staff, Council and Senate accept no 
            liability in regard to inaccuracies, if any, that may occur in the content of this provisional quotation, 
        </li>
        <li>
            is offered with further explanation that appears at the end of the final quotation document.
        </li>
    </ol>
    <p>
        <b>
            I hereby declare that I have read, understood and accept the conditions and requirements of this Provisional Quotation and or Pro-forma Invoice. 
        </b>
    </p>
</div>